import {DisclaimerKind} from '../types';
import {useDisclaimer} from './use-disclaimer';
const DisclaimerReferenceWrapper = (
  disclaimerTranslation: string,
  disclaimerReferenceLabel: string | undefined,
  closeButtonLabel: string
) => {
  return useDisclaimer(
    disclaimerTranslation,
    DisclaimerKind.AppRendered,
    disclaimerReferenceLabel,
    closeButtonLabel
  );
};

export const getDisclaimerReferenceProps = (
  disclaimerTranslation: string | undefined,
  disclaimerReferenceLabel: string | undefined,
  closeButtonLabel: string
) => {
  return disclaimerTranslation
    ? DisclaimerReferenceWrapper(
        disclaimerTranslation,
        disclaimerReferenceLabel,
        closeButtonLabel
      )
    : undefined;
};
